import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { InfoCardGrid } from '../components/sections/InfoCardGrid';
import { executiveHeroBlocks } from '../data/executiveHero';
export function ExecutiveHeroPage() {
  return <div data-id="element-248" data-mp="1sstvvgtlhtdh">
      <PageHeader eyebrow="Executive Hero & Board Positioning" title="Executive Statement of Purpose and Enterprise Leadership Scope" dark data-id="element-249" data-mp="1st2abd5d96qs" />
      <section className="bg-navy pb-20 lg:pb-28" data-id="element-250" data-mp="2lgy1y3g2w8gp">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-251" data-mp="2ph8gi4hxs776">
          <InfoCardGrid items={executiveHeroBlocks} columns={3} variant="dark" data-id="element-252" data-mp="2pgqbaidaqin4" />
        </div>
      </section>
    </div>;
}